import { ReactNode, useCallback, useEffect, useRef, useState } from "react"
import { BiChevronUp, BiChevronDown } from "react-icons/bi"

const AccordionFaq = ({
    question,
    answer,
    isTable,
    id,
    active,
    onClickQuestion,
  }: {
    question: string
    answer: any
    isTable?: boolean
    id: any,
    active:boolean,
    onClickQuestion(id:number):void
  }) =>
{
    //const [openQuestion, setOpenQuestion] = useState('collapsed');
    //const [openAnswer, setOpenAnswer] = useState('collapse');
    
    function createMarkup() 
    {
        return { __html: answer }
    }


    return(

        <li className="pergunta-faq card">
            <div className="card-header" id={id}>
                <a 
                    onClick={() => {onClickQuestion(id)}} 
                    className={`question titulo-pergunta-faq ${ active ? '': 'collapsed' }`} 
                    href="javascript:;"
                    id={'question_' + id}
                >
                    <span>{question}</span> 
                    {active==true ? <BiChevronUp size={20} fill={'#002c6c'} /> : <BiChevronDown size={20} fill={'#002c6c'} />}
                </a>
            </div>
            <div id={'answer_'+ id} className={`answer ${active ? 'collapse show': 'collapse'}`} data-parent="#accordionFaq">
            {isTable ?<div className="card-body resposta-faq">{answer}</div>  :
                <div className="card-body resposta-faq">
                    <p dangerouslySetInnerHTML={createMarkup()}></p> 
                </div>
            }
            </div>
        </li>	
            
    )
}

export default AccordionFaq